import isEqual from "lodash/isEqual";
import { createRecord } from "Utils";
const createHiddenNodeJSON = (id) => ({
    Id: id,
    ParentId: null,
    X: 0,
    Y: 0,
    Width: 0,
    Height: 0,
    IsGroup: false,
    Ports: []
});
export const prepareNodes = ({ documentGraphData, prevData }) => {
    var _a;
    const nodesSourceForServer = new Map();
    const prevNodes = createRecord(prevData.Nodes, "Id");
    const nodesOnGraph = new Map(documentGraphData.Nodes.map(item => [item.Id, item]));
    const nodesForServer = new Map();
    const addNodeSourceForServer = (item) => {
        var _a;
        if (item) {
            nodesSourceForServer.set(item.NodeId, item);
            nodesForServer.set(item.NodeId, (_a = nodesOnGraph.get(item.NodeId)) !== null && _a !== void 0 ? _a : createHiddenNodeJSON(item.NodeId));
        }
    };
    (_a = documentGraphData.NodesSource) === null || _a === void 0 ? void 0 : _a.forEach(item => {
        const prev = prevData.NodesSource[item.NodeId];
        if (!prev) {
            addNodeSourceForServer(item);
            return;
        }
        if (isEqual(prev, item)) {
            return;
        }
        addNodeSourceForServer(item);
    });
    documentGraphData.Nodes.forEach(item => {
        if (nodesForServer.has(item.Id)) {
            return;
        }
        const prev = prevNodes[item.Id];
        if (isEqual(prev, item)) {
            return;
        }
        const prevNodesSource = prevData.NodesSource[item.Id];
        addNodeSourceForServer(prevNodesSource);
    });
    return {
        nodesSourceForServer,
        nodesForServer
    };
};
